
    const _each = require("lodash/each");
    const _times = require("lodash/times");
    const _escape = require("lodash/escape");
    const _throttle = require("lodash/throttle");

    const _ = {
        each: _each,
        times: _times,
        escape: _escape,
        throttle: _throttle,
    };

    module.exports = function(context) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="slide-control__element fullscreen-overlay__buy m0"><div class="fullscreen-overlay-inner"><span class="fullscreen-overlay-price heading-2 block mb10">';
 if (context.sale_price) { ;
__p += '<del>' +
__e( context.price ) +
'</del><span class="price sale">' +
__e( context.sale_price ) +
'</span>';
 } else { ;
__p +=
__e( context.price );
 } ;
__p += '</span><span class="fullscreen-overlay-retailer block mb15">At ' +
((__t = ( context.name )) == null ? '' : __t) +
'</span><a href="' +
__e( context.url ) +
'" class="btn btn--full-width" target="_blank" is="lead-link" reason="fullscreen-overlay-button">buy</a></div></div>';
return __p
};
    